var contains = require('../array/contains');

var values = require('./values');

module.exports = function (obj, value) {
  return contains(values(obj), value);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/object/has-value.js
// module id = 223
// module chunks = 0